/**
 *
 * Advanced Mobile Grid row constants
 *
 */

export const LEFT_BLOCK_WIDTH = 50;
export const RIGHT_BLOCK_WIDTH = 50;
